import { createReducer } from '@reduxjs/toolkit'

import {
  agentLoggedIn,
  loggedOutClubOne,
  receivedClubOneDetails,
  updateDeliveryDetailsField,
  updateDeliveryDetailsValidity
} from '../actions/actions'

const initialState = {
  values: {
    firstName: '',
    lastName: '',
    email: ''
  },
  valid: false
}

const deliveryDetails = createReducer(initialState, {
  [updateDeliveryDetailsField]: (state, { payload: { name, value } }) => {
    state.values[name] = value
  },
  [loggedOutClubOne]: () => initialState,
  [receivedClubOneDetails]: (state, { payload: user }) => {
    state.values.email = user.email
    state.valid = true
  },
  [agentLoggedIn]: (state, { payload }) => {
    state.valid = true
    state.values.email = payload.email
    state.values.firstName = payload.firstName
    state.values.lastName = payload.lastName
  },
  [updateDeliveryDetailsValidity]: (state, { payload }) => {
    state.valid = payload
  }
})

export default deliveryDetails
